import React from 'react';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import {Route} from 'react-router-dom';

export default [
  <Route key="/business/showcase/youcam-tutorial" element={<ShowocaseLayout />}>
    <Route path="business/showcase/youcam-tutorial" element={<AsyncPage />} />
  </Route>,
  // tutorial special link for Allure
  <Route
    key="/business/showcase/allure-november-look"
    element={<ShowocaseLayout />}
  >
    <Route
      path="business/showcase/allure-november-look"
      element={<AsyncPage />}
    />
  </Route>,
];
